import {FC, memo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {TBreakpointStyle, useQuery} from 'ui-kit';
import {useScreenSize} from '@kcast-fe/ui-kit';

import {MenuHeader, ThreadList} from './components';

interface IProps {
  width: TBreakpointStyle;
  onClose: () => void;
}

const NavigationMenuFC: FC<IProps> = ({width, onClose}) => {
  const query = useQuery();

  const {isLessThan768} = useScreenSize();

  return (
    <Box
      w={width}
      h={'100%'}
      pos={'absolute'}
      p={isLessThan768 ? '4px 0 12px 12px' : '12px 0 12px 12px'}
      transition={'width var(--tr-100-ei)'}
      zIndex={15}
      left={0}
      top={0}
    >
      <Flex
        h={'100%'}
        bg={'white'}
        borderRadius={isLessThan768 ? '24px' : '12px'}
        overflowY={'hidden'}
        flexDirection={'column'}
        boxShadow={'{shadows.shadow_menu}'}
      >
        <MenuHeader query={query.query} updateQuery={query.update} />
        <ThreadList query={query.query} onCloseMenu={onClose} />
      </Flex>
    </Box>
  );
};

export const NavigationMenu = memo(NavigationMenuFC);
